import packingRequest from "../request/packing"

const apiRequest = packingRequest()

export const createSettingBoxes = async (payload) => {
    const {data} = await apiRequest({
        url: `/packing/shipping-box`,
        method: 'POST',
        data: payload
    })

    return data
}

export const getDetailSettingBoxes = (id) => {
    return apiRequest({
        url: `/packing/shipping-box/${id}`,
        method: 'GET'
    })
}

export const updateSettingBoxes = (id, data) => {
    return apiRequest({
        url: `/packing/shipping-box/${id}/update`,
        method: 'PUT',
        data: data
    })
}

export const getSettingBoxesHistory = (payload) => {
    return apiRequest({
        url: `/packing/histories/search`,
        method: 'POST',
        data: payload
    })
}